





































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { getWithdrawalsCode, detailTax, drawCash } from '@/api/user/user';
const realName = () => import('@/components/realName.vue');
@Component({
  components: {
    realName,
  },
})
export default class Alipay extends Vue {
  @Prop() private withdrawScope: any;
  @Prop() private withdrawType: any;
  @Prop() private withdrawLimit: any;
  private keyword: string = process.env.VUE_APP_KEYWORD;
  private taxDetail: any = {};
  // 提现确认 modal
  private confirmVisble: boolean = false;
  //
  // 实名认证 modal
  private realNameShow: boolean = false;
  private realNameMsg: string[] = [
    '信息必须真实有效，填写无效信息无法进行提现',
    '请确保您的支付宝或微信账号与实名认证信息相符合，负责将无法进行提现',
  ];
  private extract: object = {
    // 表单字段
    amount: '100',
    account: '',
    name: '',
    mobile: '',
    code: '',
  };
  private created() {
    this.init();
  }
  private async init() {
    const res: any = await detailTax({
      amount: 100,
      trade_type: 'alipay',
    });
    this.$nextTick(() => {
      this.taxDetail = res;
    });
  }
  private ruleValidate: object = {
    // 表单规则
    amount: [
      {
        required: true,
      },
    ],
    account: [
      {
        required: true,
        message: '请输入您的支付宝账号，如: 15500000000',
        trigger: 'blur',
      },
    ],
    name: [
      {
        required: true,
        message: '请输入您的姓名，如: 张三',
        trigger: 'blur',
      },
    ],
    mobile: [
      {
        required: true,
        message: '请输入您的手机号码',
        trigger: 'blur',
        type: 'number',
        transform: value => {
          const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
          if (!reg.test(value)) {
            return false;
          } else {
            return Number(value);
          }
        },
      },
    ],
    code: [
      {
        required: true,
        message: '请输入您收到的短信验证码',
        trigger: 'blur',
        type: 'number',
        transform: value => {
          const reg = /^\d{6}$/;
          if (!reg.test(value)) {
            return false;
          } else {
            return Number(value);
          }
        },
      },
    ],
  };
  private time: number = 60; // 倒计时时间
  private inTerVal: any = null; // 倒计时实例
  private acceptCode: boolean = false; // 短信验证码触发状态
  private customWithdraw = null
  // 发送短信验证方法
  private sendCode() {
    const fieldsToValidate = ['account', 'name', 'mobile'];
    const self = this;
    let falg = true;
    fieldsToValidate.map(item => {
      (self.$refs.formValidate as any).validateField(item, error => {
        if (error) {
          falg = false;
        }
      });
    });
    if (falg) {
      this.getWidthdrawCode();
    }
  }
  // 切换提现金额
  private async handleAmountChange() {
    let amount = (this.extract as any).amount
    if (amount < 0 && this.withdrawType == 1) {
      this.$Modal.confirm({
        title: '请输入提现金额',
        onOk: () => {
          if (this.customWithdraw * 100 > this.withdrawLimit) {
            this.$Message.error('自定义额度不得超过' + this.withdrawLimit / 100 + "元");
            this.customWithdraw = null
          } else {
            const res: any = detailTax({
              amount: this.customWithdraw * 100,
              trade_type: 'alipay',
            });
            this.$nextTick(() => {
              this.taxDetail = res;
            });
          }
        },
        onCancel: () => {
          this.customWithdraw = null
        },
        render: (h) => {
          return h('Input', {
            props: {
              value: this.customWithdraw,
              autofocus: true,
              placeholder: '请输入提现金额，最高为' + this.withdrawLimit / 100 + "元"
            },
            on: {
              input: (val) => {
                this.customWithdraw = val;

              }
            },
          })
        }
      })
    } else {
      const res: any = await detailTax({
        amount: (this.extract as any).amount,
        trade_type: 'alipay',
      });
      this.$nextTick(() => {
        this.taxDetail = res;
      });
    }
  }
  // 获取验证码
  private async getWidthdrawCode() {
    this.$nextTick(() => {
      this.acceptCode = true;
    });
    this.countDown();
    try {
      const extract = this.extract as any;
      const res: any = await getWithdrawalsCode({
        mobile: extract.mobile,
      });
      if (res.code !== '200') {
        this.acceptCode = false;
        if (this.inTerVal) {
          clearInterval(this.inTerVal);
        }
        this.$Notice.error({
          title: '提示',
          desc: res.message || '未知错误！',
        });
      }
    } catch (err) {
      console.log(err);
    }
  }
  // 倒计时
  private countDown() {
    if (this.inTerVal) {
      clearInterval(this.inTerVal);
    }
    this.inTerVal = setInterval(() => {
      this.time--;
      if (this.time === 0) {
        this.acceptCode = false;
        this.time = 60;
        clearTimeout(this.inTerVal);
      }
    }, 1000);
  }
  // 提现 验证
  private onValidateForm() {
    (this.$refs.formValidate as any).validate((valid: boolean) => {
      if (valid) {
        if (
          this.taxDetail &&
          this.taxDetail.sum_amount + this.taxDetail.amount >= 80000
        ) {
          this.confirmVisble = true;
        } else {
          this.handleGetForm();
        }
      }
    });
  }
  // 取消提现
  private handleCancel() {
    this.confirmVisble = false;
  }
  // 提现请求
  private async handleGetForm() {
    if (this.customWithdraw && this.withdrawType == 1) {
      (this.extract as any).amount = this.customWithdraw * 100
    }
    const resp: any = await drawCash({ ...this.extract, type: 'alipay' });
    if (resp.code == '200') {
      this.$emit(
        'handleResult',
        'success',
        this.taxDetail,
        (this.extract as any).amount
      );
    } else {
      this.$Notice.error({ desc: resp.message });
    }
  }
  // 返回
  private handleBack() {
    this.time = 60;
    this.acceptCode = false;
    if (this.inTerVal) {
      clearTimeout(this.inTerVal);
    }
    (this.$refs.formValidate as any).resetFields();
    this.$emit('handleBack');
  }
  // 打开实名认证弹窗
  private openRealName() {
    this.realNameShow = true;
  }
  // 关闭实名认证弹窗
  private async closeRealName(submit) {
    if (submit) {
      // 提交实名认证 则更新数据
      const res = await detailTax({
        amount: 100,
        trade_type: 'alipay',
      });
      this.$nextTick(() => {
        this.taxDetail = res;
      });
    }
    this.realNameShow = false;
  }
}
